import { render, staticRenderFns } from "./BaseTeacherModal.vue?vue&type=template&id=08ec3ffa"
import script from "./BaseTeacherModal.vue?vue&type=script&lang=js"
export * from "./BaseTeacherModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports